import { Box, Typography } from '@mui/material';
type Props = {
  onClick?: VoidFunction;
  href: string;
};

export const VOAHeader = ({ onClick, href }: Props) => {
  return (
    <Box
      className="group block max-h-[90px] min-h-[60px] w-full text-center text-white no-underline"
      component="a"
      href={href}
      rel="noreferrer"
      sx={{
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
      target="_blank"
      onClick={onClick}
    >
      <div className="p-4">
        <Typography className="underline" variant="body2">
          Truv now supports Day 1 Certainty from Fannie Mae
        </Typography>
        <Typography className="text-white/70 group-hover:text-white" variant="body2">
          When asset data is validated through the DU validation service using data from Truv, Fannie Mae will provide
          Day 1 Certainty.
        </Typography>
      </div>
    </Box>
  );
};
